module.exports = "/_next/static/images/PersonalizationAroundTheGlobe@2x-c6c09a5dd29931a54ac2656dddf74232.png";